import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useBookCall } from "@/pages/Landing";

const links = [
  { href: "#ventures", label: "Ventures" },
  { href: "#packages", label: "Packages" },
  { href: "#work", label: "Work" },
  { href: "#about", label: "About" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const book = useBookCall();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="relative">
            <span className="block w-2.5 h-2.5 bg-neon-cyan rounded-full animate-pulse-glow" />
          </span>
          <span className="font-heading font-black text-lg tracking-tight">
            TECHSAVVY<span className="text-neon-orange">PRENEURS</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-widest text-white/60 hover:text-neon-cyan transition-colors"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/admin/login"
            data-testid="nav-admin-link"
            className="font-mono text-xs uppercase tracking-widest text-white/40 hover:text-white transition-colors"
          >
            Admin
          </Link>
          <button onClick={() => book.open()} data-testid="nav-cta" className="btn-primary !py-2.5 !px-5">
            Reserve Call
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-mono text-xs uppercase tracking-widest text-white/70 hover:text-neon-cyan"
              >
                {l.label}
              </a>
            ))}
            <Link to="/admin/login" onClick={() => setOpen(false)} className="font-mono text-xs uppercase tracking-widest text-white/50">
              Admin
            </Link>
            <button
              onClick={() => { setOpen(false); book.open(); }}
              data-testid="mobile-cta"
              className="btn-primary mt-2 w-full"
            >
              Reserve Call
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
